import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {timer} from "rxjs/index";

@Component({
    selector: 'app-unknown-route',
    templateUrl: './unknown-route.component.html',
    styleUrls: ['./unknown-route.component.css']
})
export class UnknownRouteComponent implements OnInit {

    constructor(public router: Router) {
    }

    ngOnInit() {
        timer(3000).subscribe(() => {
            this.router.navigate(['/']);
        });
    }
}
